<template>
  <div class="steamOnboarding-container">
    <b-modal
      id="steamOnboardingModal"
      ref="steamOnboardingModal"
      header-bg-variant="dark"
      header-text-variant="light"
      :hide-footer="true"
      :hide-header-close="(!showClose)"
      :no-close-on-esc="true"
      :no-close-on-backdrop="true"
      size="lg"
      :title="modalTitle"
    >
      <b-container fluid>
        <div class="email-container">
          <b-form validate ref="steamOnboardingForm" @submit.stop.prevent="onSubmit">
            <b-form-group
              label="Seu perfil na steam"
              description="Cole o link para sua steamcommunity"
            >
              <b-form-input
                type="text"
                v-model="form.steamid"
                required
                placeholder="https://steamcommunity.com/id/nickdescolado"
              ></b-form-input>
            </b-form-group>

            <div class="actions">
              <b-button type="submit" size="lg" variant="success">Salvar</b-button>
            </div>
          </b-form>
        </div>
      </b-container>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "SteamIdOnboarding",
  props: {
    showClose: Boolean
  },
  data() {
    return {
      currentSlide: 0,
      form: {
        steamid: ""
      },
      modalTitle: "Associe sua steam"
    };
  },
  methods: {
    initialize() {
      this.$refs.steamOnboardingModal.show();
    },
    onSubmit(e) {
      this.$http
        .post(`steamid.json`, { steamid: this.form.steamid })
        .then(response => {
          this.$refs.steamOnboardingModal.hide();
          // console.log(response.data);
          // this.$store.dispatch("updateUserProfile", response.data);
          // this.$notify({
          //   group: "all",
          //   title: "Seja bem-vindo oficialmente ao QUEOTA.club",
          //   type: "success"
          // });
          // this.$refs.passwordonboardingModal.hide();
        });
    }
  },
  mounted() {
    this.initialize();
  }
};
</script>

<style lang="sass" scoped>
.actions
  text-align: center
  margin-top: 20px
</style>
